import router from '../../routes/index'
import axios from 'axios'
import moment from 'moment'

const BUSINESS_TYPE_ON_DEMAND = 2

const state = {
  user: {
    permissions:[],
    catering: {
      kitchen_id: null,
      business_type: null
    },
  },
  logged: !!localStorage.getItem('token')
}

const getters = {
  isLogged: state => state.logged,
  getPermissions: state => state.user.permissions,
  getKitchenId: state => {
    return localStorage.getItem('userData')
      ? JSON.parse(localStorage.getItem('userData')).catering.kitchen_id
      : state.user.catering.kitchen_id;
  },
  // catering_id generico (Menu Diario, On Demand o Franchises) - a diferencia
  // de getKitchenId, que es el dark_kitchen_id de Foodcourt y solo existe
  // para caterings con operacion On Demand propia. No usar getKitchenId para
  // features que aplican a cualquier tipo de catering (ej. tickets de
  // soporte) - un catering solo-Menu-Diario nunca tendria kitchen_id.
  getCateringId: state => {
    return localStorage.getItem('userData')
      ? JSON.parse(localStorage.getItem('userData')).catering_id
      : state.user.catering_id;
  },
  getBusinessType: state => {
    return localStorage.getItem('userData')
      ? JSON.parse(localStorage.getItem('userData')).catering.business_type
      : state.user.catering.business_type;
  },
  isOnDemand: (state, getters) => Number(getters.getBusinessType) === BUSINESS_TYPE_ON_DEMAND,
  getUserRol: state => {
    const userData = localStorage.getItem('userData');
    if (userData) {
      const parsed = JSON.parse(userData);
      return parsed.rol || '';
    }
    return state.user.rol || '';
  },
}

const mutations = {
  SET_USER(state, user) {
    state.user = user;
  },
  LOGIN(state, data) {
    state.logged = true
    localStorage.setItem('token', data.access_token)
    localStorage.setItem('userId', data.user_id)
    localStorage.setItem('expiresAt', moment().add(data.expires_in, 'seconds').format())
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + data.access_token
  },
  LOGOUT(state) {
    state.logged = false
    state.user = {
      permissions:[],
      catering: {
        kitchen_id: null,
        business_type: null
      },
    }
    localStorage.removeItem('token')
    localStorage.removeItem('userId')
    localStorage.removeItem('expiresAt')
    localStorage.removeItem('userData');
    delete axios.defaults.headers.common['Authorization']
  }
}

const actions = {
   FETCH_USER({commit, dispatch}) {
    return  axios.get('/auth/me')
      .then(({data}) => {
        localStorage.setItem('userData', JSON.stringify(data));
        commit('SET_USER', data)
        return data
      })
      .catch(error => {
        dispatch('LOGOUT')
      })
  },
  async LOGIN({commit, dispatch}, data) {
    await commit('LOGIN', data)
    const user = await dispatch('FETCH_USER')
    if (user) {
      // TODO: restaurar routing por rol cuando se defina la ruta destino para ALMACENERO
      // (el sidebar oculta todos los ítems para ese rol — necesita ruta en la ticketera)
      router.push({name: 'pedidos'})
    }
  },
  LOGOUT({commit}) {
    commit('LOGOUT')
    // commit('CLEAR_MENUS');
    // commit('CLEAR_USERS')
    // commit('CLEAR_MEALS')
    router.push({name: 'login'})
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}
